import { AlertIcon  } from './alert';
import { BulbIcon } from './bulb';
import { MonitorIcon } from './monitor';

export const icons = [
    AlertIcon,
    BulbIcon,
    MonitorIcon,
];
